module.exports = __webpack_public_path__ + "img/Energy.f8bac754.png";